import React, { ReactNode } from "react";
import "./Sidebar.scss";

const Sidebar = ({ className, children }: { className?: string; children: ReactNode }) => {
    return <div className={`Sidebar ${className}`}>{children}</div>;
};

export default Sidebar;

const SidebarResponsiveContainer = ({ children }: { children: ReactNode }) => {
    return <div className="SidebarResponsiveContainer">{children}</div>;
};

export { SidebarResponsiveContainer };
